import { render, staticRenderFns } from "./surveyCreate.vue?vue&type=template&id=c1b56b66&scoped=true"
import script from "./surveyCreate.ts?vue&type=script&lang=ts&external"
export * from "./surveyCreate.ts?vue&type=script&lang=ts&external"
import style0 from "./surveyCreate.scss?vue&type=style&index=0&id=c1b56b66&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b56b66",
  null
  
)

export default component.exports